export default "__VITE_ASSET__BhXIVzwE__"